import { render, staticRenderFns } from "./WeeklyLimitFields.vue?vue&type=template&id=dccb7b3c"
import script from "./WeeklyLimitFields.vue?vue&type=script&lang=js"
export * from "./WeeklyLimitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports